var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 43,
    viewBox: "0 0 32 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 11.3333V0H2C0.891667 0 0 0.891667 0 2V40.6667C0 41.775 0.891667 42.6667 2 42.6667H30C31.1083 42.6667 32 41.775 32 40.6667V13.3333H20.6667C19.5667 13.3333 18.6667 12.4333 18.6667 11.3333ZM24 31C24 31.55 23.55 32 23 32H9C8.45 32 8 31.55 8 31V30.3333C8 29.7833 8.45 29.3333 9 29.3333H23C23.55 29.3333 24 29.7833 24 30.3333V31ZM24 25.6667C24 26.2167 23.55 26.6667 23 26.6667H9C8.45 26.6667 8 26.2167 8 25.6667V25C8 24.45 8.45 24 9 24H23C23.55 24 24 24.45 24 25V25.6667ZM24 19.6667V20.3333C24 20.8833 23.55 21.3333 23 21.3333H9C8.45 21.3333 8 20.8833 8 20.3333V19.6667C8 19.1167 8.45 18.6667 9 18.6667H23C23.55 18.6667 24 19.1167 24 19.6667ZM32 10.1583V10.6667H21.3333V0H21.8417C22.375 0 22.8833 0.208333 23.2583 0.583333L31.4167 8.75C31.7917 9.125 32 9.63333 32 10.1583Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 42.6667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.d99af350757fffc7d5c3a96a6ffd9b9d.svg";
export { ForwardRef as ReactComponent };